import { globalMSALInstance } from "@/lib/vue-msal/plugin";

export const TIER_PRICING_CONTRIBUTOR_ROLE = "TIER_PRICING_CONTRIBUTOR";
export const GLOBAL_ADMIN_ROLE = "global_admin";
export const TIER_PRICING_ADMIN_ROLE = "tierpricing_admin";
export const TIER_PRICING_CONTRIBUTOR_ROLE_V2 = "tierpricing_contributor";
export const SPOT_EXCLUSION_CONTRIBUTOR_ROLE = "spotexclusion_contributor";
export const SPOT_EXCLUSION_ADMIN_ROLE = "spotexclusion_admin";

export const getUserName = (): string => (globalMSALInstance ? globalMSALInstance.data.user.name : "");

export const getUserEmail = (): string => (globalMSALInstance ? globalMSALInstance.data.user.email : "");

export const getAccessToken = (): string => (globalMSALInstance ? globalMSALInstance.data.accessToken : "");

export const hasRole = (role: string): boolean =>
  globalMSALInstance ? globalMSALInstance.data.roles.includes(role) : false;

export const refreshAccessToken = async (): Promise<void> => {
  if (globalMSALInstance) {
    await globalMSALInstance.acquireTokenForce(3);
  }
};

export const initializeMSAL = async (): Promise<void> => {
  if (!globalMSALInstance) {
    throw new Error("initializeMSAL: missing MSAL global instance");
  }

  await globalMSALInstance.init();

  if (!globalMSALInstance.isAuthenticated()) {
    await globalMSALInstance.signIn("");
  }

  const token = globalMSALInstance.data.accessToken;

  if (!token) {
    return globalMSALInstance.acquireTokenForce(3);
  }
};
